import * as WelcomeConstants from './welcome.constants';

export default WelcomeConstants;
